module.exports = __webpack_public_path__ + "static/media/Nguyen_Duc_Long.919d706a.jpg";